/**
 * <nuro-video-toggle>
 *
 * Shows a poster <button> (thumbnail + play icon) until the user
 * clicks it, then swaps in the <template>'d <video> and autoplays.
 *
 * Markup:
 *   <nuro-video-toggle>
 *     <button class="nuro-video-review__btn">...thumbnail + play icon...</button>
 *     <template>
 *       <video controls autoplay playsinline>...sources...</video>
 *     </template>
 *   </nuro-video-toggle>
 */
class NuroVideoToggle extends HTMLElement {
  connectedCallback() {
    if (this._wired) return;
    this._wired = true;

    this.button = this.querySelector('button');
    this.tpl = this.querySelector('template');
    if (!this.button || !this.tpl) return;

    this.button.addEventListener('click', () => this.play());
  }

  play() {
    if (this._playing) return;
    this._playing = true;

    const clone = this.tpl.content.cloneNode(true);
    this.button.replaceWith(clone);

    const video = this.querySelector('video');
    if (!video) return;

    video.play().catch(() => {
      // browser blocked autoplay (probably needs muted) — try once muted
      video.muted = true;
      video.play().catch(() => {});
    });

    video.addEventListener('click', () => {
      if (video.paused) {
        video.play().catch(() => {});
      } else {
        video.pause();
      }
    });
    video.style.cursor = 'pointer';
  }
}

if (!customElements.get('nuro-video-toggle')) {
  customElements.define('nuro-video-toggle', NuroVideoToggle);
}
